import { toast } from 'react-toastify';
import { Button, Form, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'

export const CancelOrderModal = ({
  cancelModalOpen,
  setCancelModalOpen,
  cancelReason,
  setCancelReason,
  selectedOrder,
  cancelOrder,
}) => {
    const handleCancelSubmit = async (e) => {
        e.preventDefault();
        if (!cancelReason.trim()) return toast.error("La razón es obligatoria");
        await cancelOrder({ id: selectedOrder.id, reason: cancelReason });
    };
    return (
        <Modal isOpen={cancelModalOpen} toggle={() => setCancelModalOpen(!cancelModalOpen)} backdrop="static">
            <ModalHeader toggle={() => setCancelModalOpen(false)}>Cancelar Orden</ModalHeader>
            <Form onSubmit={handleCancelSubmit}>
                <ModalBody>
                    <FormGroup>
                        <Label>Razón de la cancelación</Label>
                        <Input type="textarea" rows="3" value={cancelReason} onChange={(e) => setCancelReason(e.target.value)} required />
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => setCancelModalOpen(false)}>
                        Cancelar
                    </Button>
                    <Button color="success" type="submit">
                        <i className="fa fa-ban me-1" /> Confirmar Cancelación
                    </Button>
                </ModalFooter>
            </Form>
        </Modal>
    )
}
